class LatencyTester
{

	ID = 0;
	Handler = null;
	CurrentPing = 999;

	constructor(url, id)
	{
		this.ID = id;
		this.Handler = new WebSocket(url);
		this.Handler.onopen = () => {

			this.ping();

			setInterval(() => {
				this.ping();
			}, 5000);

		};
	}

	ping()
	{
		const start = performance.now();

		this.Handler.send(start.toString());

		this.Handler.onmessage = event => {
			const end = performance.now();


			this.CurrentPing = Math.floor((end - start));

			LatencyUI.onDatacentrePingUpdate(this.ID, this.CurrentPing);

		};
	}

}

window.LatencyTester = LatencyTester;
